// removed by extract-text-webpack-plugin
module.exports = {"FanFeedPostList":"FanFeedPostList__FanFeedPostList___2ddZg","accepted":"FanFeedPostList__accepted___10z8a","rejected":"FanFeedPostList__rejected___kZ3wV","info":"FanFeedPostList__info___uJ3ZA","play":"FanFeedPostList__play___1JWLx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FanFeed/FanFeedPostList/FanFeedPostList.scss
// module id = 2220
// module chunks = 0